(function(){
    'use strict'

    angular
    .module('app.usuarios')
    .controller('EditarAtleta', EditarAtleta);

    EditarAtleta.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams', 'UsuariosService', 'GruposService', 'logger', '$location', 'UserInfoService', 'ApiBaseService'];

    function EditarAtleta($q, $scope, $animationsSrv, $routeParams, UsuariosService, GruposService, logger, $location, UserInfoService, ApiBaseService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.usuarioId = $routeParams.id ? $routeParams.id : 0;

        vm.tallas = [];
        vm.estadosVacunacion = [];

        vm.usuario = {
            tallaId: 0,
            estadoVacunacionId: 0,
            lateralidad: 0,
            sexo: 0
        };

        vm.uiData = {
            esOrganizador: UserInfoService.esOrganizador()
        };

        var promiseTallas = getComboData(vm.tallas, 'api/Tallas', null, 'Error al cargar las tallas');
        var promiseEstadosVacunacion = getComboData(vm.estadosVacunacion, 'api/EstadosVacunacion', null, 'Error al cargar los estados de vacunacion');

        if(vm.usuarioId){
            getById();
        }

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getById(){

            $q.all([promiseTallas, promiseEstadosVacunacion])
            .then(function(){
                UsuariosService.getById(vm.usuarioId)
                .then(function(usuario){
                    usuario.fechaNacimiento = moment(usuario.fechaNacimiento).toDate();
                    vm.usuario = usuario;
                })
                .catch(function(error){
                    $logger.error('Error al obtener los datos del usuario');
                }); 
            });
        }

        function doFormValidations()
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'tallaId' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'estadoVacunacionId' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'sexo' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'lateralidad' );
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.usuarioForm.$valid){
                if(!vm.usuario.id){
                    $logger.error('Accion no permitida');
                }
                else{
                    if($scope.usuarioForm.$dirty){
                        updateUser();
                    }
                    else{
                        logger.info('No has modificado ningún dato');
                    }
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function updateUser() {
            var promise = UsuariosService.update(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Datos modificados con éxito.');

                $location.path('/eventos');
                
            })
            .catch(function(error){
                logger.error('Hubo un erro al modificar el usuario');
            }); 
        }

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "tallaId":
                    onTallaIdChanged(property);
                    break;
                case "estadoVacunacionId":
                    onEstadoVacunacionIdChanged(property);
                    break;
                case "sexo":
                    onSexoChanged(property);
                    break;
                case "lateralidad":
                    onLateralidadChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onTallaIdChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onSexoChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onEstadoVacunacionIdChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onLateralidadChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };
    }
})();